import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo/SENAC_Negativa_Vertical.png';
import { Login } from '@mui/icons-material';
import MenuCursos from './Header/MenuCursos';
import MenuInstitucional from './Header/MenuInstitucional';
import MenuEstudante from './Header/MenuEstudante';
import MenuCPA from './Header/MenuCPA';
import MenuFaleConosco from './Header/MenuFaleConosco';
import MenuRevista from './Header/MenuRevista';
import MenuPesquisa from './Header/MenuPesquisa';
import MobileDrawerMenu from './Header/MobileDrawerMenu';
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  useMediaQuery,
  useTheme,
  Container,
  Stack,
} from '@mui/material';

const NovoHeader: React.FC = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const updateHeight = () => {
      if (headerRef.current) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${headerRef.current.offsetHeight}px`
        );
      }
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <AppBar
      position="fixed"
      ref={headerRef}
      color="primary" // usa o gradiente definido no theme.ts (MuiAppBar.colorPrimary)
      sx={{
        boxShadow: 3,
        py: 1,
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo + menu mobile */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: { xs: 'block', md: 'none' }, mr: 2 }}>
              <MobileDrawerMenu />
            </Box>
            <Link to="/home">
              <Box
                component="img"
                src={logo}
                alt="Logomarca Senac"
                sx={{
                  height: { xs: 48, md: 64 },
                  transition: 'transform 0.3s ease',
                  '&:hover': { transform: 'scale(1.05)' },
                }}
              />
            </Link>
          </Box>

          {/* Navegação desktop */}
          {!isMobile && (
            <Box component="nav">
              <Stack direction="row" spacing={4} alignItems="center">
                <MenuInstitucional />
                <MenuCursos />
                <MenuEstudante />
                <MenuPesquisa />
                <MenuRevista />
                <MenuCPA />
                <MenuFaleConosco />
              </Stack>
            </Box>
          )}

          {/* Ações à direita */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Button
              href="https://cloud.plataforma.senac.br/senacportalaluno/#/login"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              color="secondary" // laranja do tema
              startIcon={<Login fontSize="small" />}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 16,
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
                },
              }}
            >
              Portal do Aluno
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NovoHeader;
